export enum ETipoPessoa {
    Fisica = 1,
    Juridica = 2,
    Estrangeira = 3,
}
